import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import UndoIcon from "@mui/icons-material/Undo";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "../style/sidebar.css";

function Sidebar() {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);

      // Auto-close mobile menu when screen becomes desktop
      if (!mobile && isMobileOpen) {
        setIsMobileOpen(false);
      }

      // Auto-collapse on smaller screens
      if (mobile && !isCollapsed) {
        setIsCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobileOpen, isCollapsed]);

  // Handle body scroll lock for mobile sidebar
  useEffect(() => {
    if (isMobile && isMobileOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }

    return () => {
      document.body.classList.remove("sidebar-open");
    };
  }, [isMobile, isMobileOpen]);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileOpen(!isMobileOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  const closeMobileSidebar = () => {
    if (isMobile) {
      setIsMobileOpen(false);
    }
  };

  const sidebarItems = [
    {
      path: "/",
      name: "Dashboard",
      icon: <DashboardIcon className="sidebar-icon-svg" />,
      description: "Main control panel",
    },
    {
      path: "/revert",
      name: "Revert",
      icon: <UndoIcon className="sidebar-icon-svg" />,
      description: "Revert operations",
    },
    {
      path: "/delete-bets",
      name: "Delete Bets",
      icon: <DeleteIcon className="sidebar-icon-svg" />,
      description: "Remove betting data",
    },
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isMobileOpen && (
        <div className="sidebar-overlay" onClick={closeMobileSidebar}></div>
      )}

      {/* Mobile Toggle Button */}
      {isMobile && (
        <button className="mobile-sidebar-toggle" onClick={toggleSidebar}>
          <MenuIcon />
        </button>
      )}

      <div
        className={`modern-sidebar ${isCollapsed ? "collapsed" : ""} ${
          isMobile ? (isMobileOpen ? "mobile-open" : "mobile-closed") : ""
        }`}
      >
        <div className="sidebar-header">
          <div className="logo-section">
            {!isCollapsed && (
              <div className="logo-text">
                <h3>Manager</h3>
                <span>Dashboard</span>
              </div>
            )}
          </div>
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {isMobile ? (
              <CloseIcon />
            ) : isCollapsed ? (
              <MenuIcon />
            ) : (
              <CloseIcon />
            )}
          </button>
        </div>

        <div className="sidebar-content">
          <nav className="sidebar-nav">
            <div className="nav-section">
              {(!isCollapsed || isMobile) && <div className="nav-title">Navigation</div>}
              {sidebarItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-item ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                  title={isCollapsed ? item.name : ""}
                  onClick={closeMobileSidebar}
                >
                  <div className="nav-icon">{item.icon}</div>
                  {(!isCollapsed || isMobile) && (
                    <div className="nav-content">
                      <span className="nav-text">{item.name}</span>
                      <span className="nav-description">
                        {item.description}
                      </span>
                    </div>
                  )}
                  {location.pathname === item.path && (
                    <div className="active-indicator"></div>
                  )}
                </Link>
              ))}
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
